import { AbstractModel } from '../base'
import type {
  IGeofenceCircle,
  IGeofenceCircleData,
  IGeofencePolygon,
  IGeofencePolygonData
} from './geofencing.types'

/**
 * A class representing a Circle Geofence
 */
export class GeofenceCircle extends AbstractModel implements IGeofenceCircle {
  readonly id?: number
  readonly shape_type: 'circle' = 'circle'
  readonly is_active?: boolean
  readonly tolerance_m?: number
  readonly circle: { lat: number; lng: number; radius_m: number }

  constructor(data: IGeofenceCircleData) {
    super()

    // Validate required fields
    const requiredFields: (keyof IGeofenceCircleData)[] = ['circle']
    this.validate(data, requiredFields)

    // Initialize required fields
    this.circle = data.circle!

    // Initialize optional fields
    if (data.id !== undefined) {
      this.id = data.id
    }
    if (data.is_active !== undefined) {
      this.is_active = data.is_active
    }
    if (data.tolerance_m !== undefined) {
      this.tolerance_m = data.tolerance_m
    }
  }
}

/**
 * A class representing a Polygon Geofence
 */
export class GeofencePolygon extends AbstractModel implements IGeofencePolygon {
  readonly id?: number
  readonly shape_type: 'polygon' = 'polygon'
  readonly is_active?: boolean
  readonly tolerance_m?: number
  readonly polygon: { coordinates: [number, number][] }

  constructor(data: IGeofencePolygonData) {
    super()

    // Validate required fields
    const requiredFields: (keyof IGeofencePolygonData)[] = ['polygon']
    this.validate(data, requiredFields)

    // Initialize required fields
    this.polygon = data.polygon!

    // Initialize optional fields
    if (data.id !== undefined) {
      this.id = data.id
    }
    if (data.is_active !== undefined) {
      this.is_active = data.is_active
    }
    if (data.tolerance_m !== undefined) {
      this.tolerance_m = data.tolerance_m
    }
  }
}

/**
 * Factory function to create the appropriate geofence model from API data
 */
export function createGeofence(data: IGeofenceCircleData | IGeofencePolygonData) {
  if (data.shape_type === 'circle') {
    return new GeofenceCircle(data)
  }
  if (data.shape_type === 'polygon') {
    return new GeofencePolygon(data)
  }
  throw new Error('Invalid geofence shape_type')
}
